import { render, staticRenderFns } from "./AdminRouteTask.vue?vue&type=template&id=a0a6b60a&scoped=true"
import script from "./AdminRouteTask.vue?vue&type=script&lang=js"
export * from "./AdminRouteTask.vue?vue&type=script&lang=js"
import style0 from "./AdminRouteTask.vue?vue&type=style&index=0&id=a0a6b60a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a6b60a",
  null
  
)

export default component.exports